<template>
  <b-modal ref="loginNeedModal" :hide-footer="true">
    <template v-slot:modal-header>
      <a href="#">
        <img src="../../assets/images/logo-color.png" alt="Dicicil Aja" />
      </a>
      <button
        @click="hide"
        type="button"
        class="close orange"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <form role="form" class="p-lr-50">
      <h2 class="color-orange p-t-50 p-b-50 bold font-montserrat">
        Anda belum login! Login terlebih dahulu untuk melanjutkan.
      </h2>
    </form>
    <div class="w-100">
      <button class="float-right btn btn-orange semibold m-b-10" @click.prevent="redirectLogin">
        Login disini
      </button>
      <button class="float-right btn btn-orange semibold m-b-10 btn-close" @click="hide">
        kembali
      </button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LoginNeedModal",
  methods: {
    ...mapActions({
      setPopupLoginTrue: "setPopupLoginTrue",
      setPopupLoginFalse: "setPopupLoginFalse",
    }),
    redirectLogin() {
      this.setPopupLoginFalse();
      // const loginpath = window.location.pathname
      // this.$router.push({ name: 'login', query: { from: loginpath } })
      const hasDraft = sessionStorage.getItem("simulasi_draft_data");
      const loginPath = hasDraft
        ? "/produk-pembiayaan/dana-tunai/confirmation"
        : window.location.pathname;
      this.$router.push({ name: "login", query: { from: loginPath } });
    },
    show() {
      this.setPopupLoginTrue();
      this.$refs["loginNeedModal"].show();
    },
    hide() {
      this.setPopupLoginFalse();
      sessionStorage.removeItem("simulasi_draft_data");
      this.$refs["loginNeedModal"].hide();
    },
  },
};
</script>

<style scoped>
.btn-close {
  margin-right: 10px;
  background: white !important;
  color: #f6861f !important;
  border: 2px solid #f6861f;
}
.btn-close:hover {
  color: white !important;
}
</style>
